export { default } from './Industries';
